// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSlotsIndicator_spinner__2uABh","rotate-forever":"LoadingSlotsIndicator_rotate-forever__dR85E","label":"LoadingSlotsIndicator_label__gMpda"};